import gql from 'graphql-tag'
import { getProvider } from '@/apollo'

const tariffOptionsModule = {
  namespaced: true,
  state: {
    tariffOptions: []
  },
  mutations: {
    setTariffOptions(state, tariffOptions) {
      state.tariffOptions = tariffOptions
    }
  },
  actions: {
    async fetchTariffOptions({ commit }) {
      const apolloClient = getProvider().defaultClient
      try {
        const response = await apolloClient.query({
          query: gql`
            query bookTariffOptions {
              tariffoptions {
                bookedTariffoptions {
                  bookedTariffoptions {
                    tariffoptionId
                  }
                }
              }
            }
          `
        })
        const tariffOptions = response.data.tariffoptions.bookedTariffoptions.bookedTariffoptions
        commit('setTariffOptions', tariffOptions)
      } catch (error) {
        console.error('Fehler beim Laden der Tarifoptionen', error)
      }
    }
  },
  getters: {
    isTariffOptionFound: (state) => (searchTariffId) => {
      return state.tariffOptions.some(opt => opt.tariffoptionId === searchTariffId)
    },
    tariffOptions: (state) => state.tariffOptions
  }
}

export { tariffOptionsModule }
